<template>
	<div>
		<buttonlist
				@help="help"
			@opentable="opentable"
			@search="search"
			@reflash="reflash"
			@exps="exps"
			ref="SetBtn"
		></buttonlist>
		<wTable
				id="xpane-0"
				:data="dataSet"
				:loading="loading"
				queryData="PurReturnLineViewInfo"
				:filter_language="['Order_Status','Finance_Status','Negative_Flag']"
				:filter_thousandth="['Pur_Measure_Actually_qty','Inv_Measure_Actually_qty','Unit_price',
				'ReleaseInvoiceQty','CreateInvoiceQty']"
				:filter_thousandth_puramount="['Total_Amount','Line_Total_Amount']"
				:filter_date="['Finance_Date','Create_Date']"
				:header="tableHeader"
				:option="tableOption"
				:checkflg="false"
				@lct="lct"
				ref="singleTable"
		></wTable>
		<!--<el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			:header-cell-style="$limits.headerClass"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Order_No" :label="$t('getapi[1929]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="PO_Code" :label="$t('getapi[1710]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Payment_Mode" :label="$t('getapi[1099]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Finance_Date" :label="$t('getapi[1857]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[1858]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[1859]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[742]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Negative_Flag" :label="$t('getapi[1930]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Order_Status" :label="$t('getapi[1861]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Finance_Status" :label="$t('getapi[1862]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Total_Amount" :label="$t('getapi[1863]')" align="right" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Line_No" :label="$t('getapi[1425]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Receive_Order_No" :label="$t('getapi[1931]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Receive_Order_Line_No" :label="$t('getapi[1932]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_name" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_model" :label="$t('getapi[1425]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_spec" :label="$t('getapi[125]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Pur_Measure" :label="$t('getapi[1166]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Pur_Measure_Actually_qty" :label="$t('getapi[1933]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Exchange_rate" :label="$t('getapi[3599]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Inv_Measure" :label="$t('getapi[1340]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Inv_Measure_Actually_qty" :label="$t('getapi[1934]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Batch_No" :label="$t('getapi[1763]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Sequence_No" :label="$t('getapi[1764]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Unit_price" :label="$t('getapi[1410]')" align="right" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Line_Total_Amount" :label="$t('getapi[1881]')" v-if="authority_showprice"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Line_Remark" :label="$t('getapi[4279]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="ReleaseInvoiceQty" :label="$t('getapi[1885]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="CreateInvoiceQty" :label="$t('getapi[1884]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="order_category" :label="$t('getapi[1866]')"></el-table-column>
			<el-table-column show-overflow-tooltip fixed="right" :label="$t('getapi[6048]')" width="120">
				<template slot-scope="scope">
					<el-button @click.native.prevent="lct(scope)" type="text" size="mini">采购业务图</el-button>
				</template>
			</el-table-column>
		</el-table>-->
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="100"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="PurReturnLineViewInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[962]')" queryData="PurReturnLineViewInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'purreturndetailview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
            tableHeader: [],
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            authority_showprice: false,
            scrollTop:0,
		};
	},
    watch:{
        dataSet: function(){
            let that = this
            that.$nextTick(function() {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.colsort()
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('PurReturnLineViewInfo', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1138]"),this.$t("getapi[16]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
            if(that.$limits.authority('plv4', 30, 1) ==  0){
                that.authority_showprice = false
            } else {
                that.authority_showprice = true
            }
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 217, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 217, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'PurReturnLineViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Pur/Return/OverViewDataList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			/*let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Pur/Return/OverViewExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "PurReturnLineViewInfo",
                fromname: that.$t('getapi[962]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		//销售关系
		lct(row) {
            let that = this
            that.$store.commit('setSharedParams',row.row);
			let item = {
				label: '采购业务图',
				name: 'purbusiness',
				path: '/purbusiness/out',
				url: '/purbusiness/out',
				icon: 'video-play'
			};
			this.$router.push({ path: '/purbusiness/out'});
			this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
